module.exports = __webpack_public_path__ + "img/sz001-001.84412e3c.jpg";